import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import logo from '../images/newlogo-small.png'
import userImage from '../images/user.png'
//import './NavMenu.css';


export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (

            <div className="sticky" style={{ marginBottom: '-64.3333px' }}>
                <div className="main-menu is-expanded ps main-navbar hor-menu menu-hover">
                    <div className="main-container-1 active container">
                        <div className="sidemenu-logo">

                        </div>
                        <div className="main-body-1">
                            <div className="slide-left disabled active d-none" id="slide-left">
                                <i className="fe fe-chevron-left"></i>
                            </div>
                            <ul className="menu-nav nav" style={{ marginLeft: 0, marginRight: 0 }}>

                                <li className="nav-header active">
                                    <span className="nav-label">Home</span>
                                </li>
                                <li className="nav-item active">
                                    <NavLink tag={Link} className="" to="/home">
                                        <span className="shape1"></span>
                                        <span className="shape2"></span>
                                        <i className="ti-home menu-icon hor-icon"></i>
                                        <span className="sidemenu-label">Home</span>
                                    </NavLink>
                                </li>
                                <li className="nav-item active">
                                    <NavLink tag={Link} className="" to="/companies">
                                        <span className="shape1"></span>
                                        <span className="shape2"></span>
                                        <i className="ti-bookmark-alt menu-icon hor-icon"></i>
                                        <span className="sidemenu-label">
                                            Companies
                                        </span>
                                    </NavLink>

                                </li>
                                <li className="nav-item active">
                                    <NavLink tag={Link} to="/auctioneers">
                                        <span className="shape1"></span>
                                        <span className="shape2"></span>
                                        <i className="ti-id-badge menu-icon hor-icon"></i>
                                        <span className="sidemenu-label">
                                            Auctioneers
                                        </span>
                                    </NavLink>
                                </li>
                                <li className="nav-item active">
                                    <NavLink tag={Link} to="/poolingCenters">
                                        <span className="shape1"></span>
                                        <span className="shape2"></span>
                                        <i className="ti-id-badge menu-icon hor-icon"></i>
                                        <span className="sidemenu-label">
                                            Pooling Centers
                                        </span>
                                    </NavLink>
                                </li>
                                <li className="nav-item active">
                                    <NavLink tag={Link} to="/traders">
                                        <span className="shape1"></span>
                                        <span className="shape2"></span>
                                        <i className="ti-user menu-icon hor-icon"></i>
                                        <span className="sidemenu-label">Traders</span>
                                    </NavLink>
                                </li>
                                <li className="nav-item active">
                                    <NavLink tag={Link} to="/auctions">
                                        <span className="shape1"></span>
                                        <span className="shape2"></span>
                                        <i className="ti-archive menu-icon hor-icon"></i>
                                        <span className="sidemenu-label">Auctions</span>
                                    </NavLink>
                                </li>
                                <li class="nav-item active slide has-sub">
                                    <NavLink className="" >
                                        <span className="shape1"></span>
                                        <span className="shape2"></span>
                                        <i className="ti-bar-chart menu-icon hor-icon"></i>
                                        <span className="sidemenu-label">Reports</span>
                                    </NavLink>
                                    <ul class="slide-menu child1" >
                                        <li>
                                            <NavLink className="" tag={Link} to="/auctionHistory">
                                                <span className="shape1"></span>
                                                <span className="shape2"></span>
                                                <i className="ti-agenda menu-icon hor-icon"></i>
                                                <span className="sidemenu-label">Auction History</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="" tag={Link} to="/tradingHistory">
                                                <span className="shape1"></span>
                                                <span className="shape2"></span>
                                                <i className="ti-agenda menu-icon hor-icon"></i>
                                                <span className="sidemenu-label">Trading History</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="" tag={Link} to="/currentLoginDetail">
                                                <span className="shape1"></span>
                                                <span className="shape2"></span>
                                                <i className="ti-agenda menu-icon hor-icon"></i>
                                                <span className="sidemenu-label">Login Details</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="" tag={Link} to="/weeklyAuctionReport">
                                                <span className="shape1"></span>
                                                <span className="shape2"></span>
                                                <i className="ti-agenda menu-icon hor-icon"></i>
                                                <span className="sidemenu-label">Weekly Auction Report</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="" tag={Link} to="/monthlyAuctionReport">
                                                <span className="shape1"></span>
                                                <span className="shape2"></span>
                                                <i className="ti-agenda menu-icon hor-icon"></i>
                                                <span className="sidemenu-label">Monthly Auction Report</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="" tag={Link} to="/fullAuctionReport">
                                                <span className="shape1"></span>
                                                <span className="shape2"></span>
                                                <i className="ti-agenda menu-icon hor-icon"></i>
                                                <span className="sidemenu-label">Full Auction Report</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="" tag={Link} to="/userFeeReport">
                                                <span className="shape1"></span>
                                                <span className="shape2"></span>
                                                <i className="ti-agenda menu-icon hor-icon"></i>
                                                <span className="sidemenu-label">User Fee Report</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="" tag={Link} to="/csrReport">
                                                <span className="shape1"></span>
                                                <span className="shape2"></span>
                                                <i className="ti-agenda menu-icon hor-icon"></i>
                                                <span className="sidemenu-label">CSR Report</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div className="slide-right d-none" id="slide-right">
                                <i className="fe fe-chevron-right"></i>
                            </div>
                        </div>
                    </div>
                    <div className="ps__rail-x" style={{ left: 0, top: 0 }}>
                        <div className="ps__thumb-x" tabIndex="0" style={{ left: 0, width: 0 }}></div>
                    </div>
                    <div className="ps__rail-y" style={{ top: 0, height: '55px', right: 0 }}>
                        <div className="ps__thumb-y" tabIndex="0" style={{ top: 0, height: 0 }}></div>
                    </div>
                </div>
            </div>
            //<header>
            //  <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
            //          <NavbarBrand tag={Link} to="/home">SpicesBoard</NavbarBrand>
            //    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            //    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
            //      <ul className="navbar-nav flex-grow">
            //        <NavItem>
            //          <NavLink tag={Link} className="text-dark" to="/home">Home</NavLink>
            //        </NavItem>
            //        <NavItem>
            //          <NavLink tag={Link} className="text-dark" to="/counter">Counter</NavLink>
            //        </NavItem>
            //        <NavItem>
            //          <NavLink tag={Link} className="text-dark" to="/fetch-data">Fetch data</NavLink>
            //        </NavItem>
            //      </ul>
            //    </Collapse>
            //  </Navbar>
            //</header>
        );
    }
}
